import React from "react"

import { Image } from "./helpers"

export const AboutDan = () => {
  return (
    <div id="about" className="pt-16 overflow-hidden bg-white lg:pt-24">
      <div className="relative max-w-xl px-4 mx-auto sm:px-6 lg:px-8 lg:max-w-screen-xl">
        <div className="relative">
          <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="lg:col-start-2">
              <h4 className="text-2xl font-extrabold leading-8 tracking-tight text-gray-900 font-header sm:text-3xl sm:leading-9">
                Hi. I’m your reading teacher, {" "}
                <a
                  href="https://www.linkedin.com/in/danstowell/"
                  target="_blank"
                  className="transition-colors duration-200 text-primary-600 hover:text-primary-800"
                >
                  {" "}
                  Mr. Stowell
                </a>
                .
              </h4>
              <p className="mt-3 text-lg leading-7 text-gray-500 font-body">
                I’ve got a secret. I’m not a natural reader. But I do know how
                to read well.
              </p>
              <p className="mt-3 text-lg leading-7 text-gray-500 font-body">
                As a student, from elementary school through college, reading 
                intimidated me. Words on a page didn’t make sense in my head. 
                Reading increasingly felt like a monumental task, and I was a
                master of all the tricks to avoid it and still get the grade.
              </p>
              <p className="mt-3 text-lg leading-7 text-gray-500 font-body">
                But my real learning suffered. Regardless of grades, I was behind. 
              </p>
              <p className="mt-3 text-lg leading-7 text-gray-500 font-body">
                Then I learned how reading worked. By studying the science of
                reading and the successes - and failures - of reading education, 
                I discovered that reading mastery isn’t something we’re born with. 
                It has to be taught. For a over decade as a researcher, 
                tutor, and public school teacher, I’ve been doing just that:{" "}
                <b>
                  teaching students, young and old, how to read well... 
                  for school, for standardized tests, for business, for
                  life
                </b>
                .
              </p>
              <p className="mt-3 text-lg leading-7 text-gray-500 font-body">
                Now it's your turn to learn how reading works. With customized, 
                one-on-one lessons, you will read text faster, with better
                comprehension, and with more interest and enjoyment than you ever
                thought possible. Best of all, these skills literally improve 
                with every page. Once you “get” reading, you've got it for life.
              </p>
            </div>

            <div className="relative mt-10 -mx-4 lg:mt-0 lg:col-start-1">
              <div className="mx-auto overflow-hidden sm:rounded-full w-96 h-96">
                <Image className="relative " src="Dan.png" alt="Dan Stowell" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
